module.exports = __webpack_public_path__ + "img/lightRJ2.ea996a6b.png";